<div class="smooth-scrolling">

    <!-- user detail start -->

    <section class="user-detail-section">
        <div class="user-container">
            <div class="user-title">
                <h3>Hello {{mUserProfileData.first_name}} {{mUserProfileData.last_name}}</h3>
            </div>
            <div class="user-detail-content d-lg-flex d-none">
                <div class="d-flex align-items-start user-res-horizontal w-100">
                    <div class="mx-300">
                        <div class="nav flex-column nav-pills user-vertical" id="v-pills-tab" role="tablist"
                            aria-orientation="vertical">
                            <button class="nav-link active" id="profile-tabs" data-bs-toggle="pill"
                                data-bs-target="#profiles" type="button" role="tab" aria-controls="profiles"
                                aria-selected="false">
                                <div class="profile-icon a-tab-w">
                                    <div class="profile-text">
                                        <h5>your profile</h5>
                                    </div>
                                </div>
                            </button>
                            <button class="nav-link" id="order-tab" data-bs-toggle="pill" data-bs-target="#order"
                                type="button" role="tab" aria-controls="order" aria-selected="false" (click)="clickOrders()">
                                <div class="profile-icon a-tab-w">
                                    <div class="profile-text">
                                        <h5>your orders</h5>
                                    </div>
                                </div>
                            </button>
                            <button class="nav-link" id="my-wishlist-tab" data-bs-toggle="pill"
                                data-bs-target="#my-wishlist" type="button" role="tab" aria-controls="my-wishlist"
                                aria-selected="false">
                                <div class="wishList-icon a-tab-w">
                                    <div class="profile-text">
                                        <h5>My wishlist</h5>
                                    </div>
                                </div>
                            </button>
                            <button class="nav-link" id="saved-address-tab" data-bs-toggle="pill"
                                data-bs-target="#saved-address" type="button" role="tab" aria-controls="saved-address"
                                aria-selected="false">
                                <div class="address-icon a-tab-w">
                                    <div class="profile-text">
                                        <h5>your addresses</h5>
                                    </div>
                                </div>
                            </button>
                            <button class="nav-link" id="reward-point-tab" data-bs-toggle="pill"
                                data-bs-target="#reward-point" type="button" role="tab" aria-controls="reward-point"
                                aria-selected="false">
                                <div class="support-icon a-tab-w">
                                    <div class="profile-text">
                                        <h5>customer Support</h5>
                                    </div>
                                </div>
                            </button>
                        </div>
                    </div>
                    <div class="tab-content user-content" id="v-pills-tabContent">
                        <div class="tab-pane fade show active" id="profiles" role="tabpanel"
                            aria-labelledby="profile-tabs">
                            <app-profile  [webView]="true"></app-profile>
                        </div>

                        <div class="tab-pane fade" id="order" role="tabpanel" aria-labelledby="order-tab">

                            <app-my-orders *ngIf="newOrder == true" [newOrderFrom]="true" [newOrderDetail]="newOrderDetail" (saveClick)="downloadAsPDF($event)"></app-my-orders>

                            <app-my-orders *ngIf="newOrder != true" [newOrderFrom]="false" (saveClick)="downloadAsPDF($event)"></app-my-orders>
                        </div>
                        <div class="tab-pane fade scrollbar" id="my-wishlist" role="tabpanel" aria-labelledby="my-wishlist-tab">
                            <app-my-wishlist></app-my-wishlist>
                        </div>
                        <div class="tab-pane fade" id="saved-address" role="tabpanel"
                            aria-labelledby="saved-address-tab">
                            <app-address [webView]="true"></app-address>
                        </div>
                        <div class="tab-pane fade" id="save-payment" role="tabpanel" aria-labelledby="save-payment-tab">
                            <app-payment-methodas></app-payment-methodas>
                            </div>
                        <div class="tab-pane fade" id="reward-point" role="tabpanel" aria-labelledby="reward-point-tab">
                            <app-need-help [webView]="true"></app-need-help></div>
                    </div>
                </div>
            </div>

            <div class="res-user-detail d-lg-none d-flex">
                <div class="nav flex-column nav-pills user-vertical" id="v-pills-tab" role="tablist"
                    aria-orientation="vertical">
                    <div class="res-button-d">
                        <button class="nav-link active" id="profile-tabs" data-bs-toggle="pill"
                            data-bs-target="#profiles" type="button" role="tab" aria-controls="profiles"
                            aria-selected="false" (click)="yourProfile('profile')">
                            <div class="profile-icon a-tab-w">
                                <div class="profile-text">
                                    <h5>your profile</h5>
                                </div>
                            </div>
                        </button>
                        <button class="nav-link" id="order-tab" data-bs-toggle="pill" data-bs-target="#order"
                            type="button" role="tab" aria-controls="order" aria-selected="false">
                            <div class="order-icon a-tab-w" (click)="yourProfile('order')">
                                <div class="profile-text ">
                                    <h5>Your orders</h5>
                                </div>
                            </div>
                        </button>
                        <button class="nav-link" id="my-wishlist-tab" data-bs-toggle="pill"
                            data-bs-target="#my-wishlist" type="button" role="tab" aria-controls="my-wishlist"
                            aria-selected="false" (click)="yourProfile('wishlist')">
                            <div class="wishList-icon a-tab-w">
                                <div class="profile-text ">
                                    <h5>My wishlist</h5>
                                </div>
                            </div>
                        </button>
                        <button class="nav-link" id="saved-address-tab" data-bs-toggle="pill"
                            data-bs-target="#saved-address" type="button" role="tab" aria-controls="saved-address"
                            aria-selected="false" (click)="yourProfile('address')">
                            <div class="address-icon a-tab-w">
                                <div class="profile-text">
                                    <h5>your addresses</h5>
                                </div>
                            </div>
                        </button>
                        <button class="nav-link" id="reward-point-tab" data-bs-toggle="pill" (click)="needHelp()"
                            data-bs-target="#reward-point" type="button" role="tab" aria-controls="reward-point"
                            aria-selected="false">
                            <div class="support-icon a-tab-w">
                                <div class="profile-text">
                                    <h5>customer Support</h5>
                                </div>
                            </div>
                        </button>
                    </div>
                </div>
            </div>

        </div>
    </section>
</div>
   <!-- Footer START -->
   <app-footer-bg></app-footer-bg>
   <!-- Footer END -->

<table hidden id="pdfTable" #pdfTable style="width: 100%;padding: 20px; color: #000;">
    <tr>
        <td style="font-size: 25px;padding: 20px 15px 10px;">
            <b>Order Invoice</b>
        </td>
    </tr>
    <tr>
        <td>
            <hr style="border: 1px solid #ccc;margin: 0;">
        </td>
    </tr>
    <tr>
        <td style="padding: 15px;">
            <table style="width: 100%;">
                <tr>
                    <td style="width: 50%;">
                        <table style="width: 100%;">
                            <tr>
                                <td style="font-size: 12px;">Order Number</td>
                            </tr>
                            <tr>
                                <td style="font-size: 12px;">{{mOrderDetail?.order_number}}</td>
                            </tr>
                            <tr>
                                <td style="font-size: 12px;">Placed on :
                                    <b>{{showDate(mOrderDetail?.order_date)}}</b>
                                </td>
                            </tr>
                        </table>
                    </td>
                    <td style="text-align: right;width: 50%;" *ngIf="mOrderDetail?.cod==false">
                        <table style="width: 100%;">
                            <tr>
                                <td style="font-size: 12px;">Total</td>
                            </tr>
                            <tr>
                                <td style="font-size: 12px;">₹{{mOrderDetail?.order_amount}}</td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>
        </td>
    </tr>
    <tr>
        <td>
            <hr style="border: 1px solid #ccc;margin: 0;">
        </td>
    </tr>
    <tr>
        <td style="padding: 15px;">
            <table style="width: 100%;">
                <tr>
                    <td style="font-size: 15px;">Shipping Address</td>
                </tr>
                <tr>
                    <td style="font-size: 12px;padding-top: 10px;">{{mOrderDetail?.customer_detail?.first_name}}
                    </td>
                </tr>
                <tr>
                    <address style="font-size: 12px;">{{mOrderDetail?.user_address}}></address>
                </tr>
            </table>
        </td>
    </tr>
    <tr>
        <td>
            <hr style="border: 1px solid #ccc;margin: 0;">
        </td>
    </tr>
    <tr>
        <td style="padding: 15px;">
            <table style="width: 100%;">
                <tr>
                    <td style="font-size: 12px;color: #2c2c2c;">Shipment 1 of 1</td>
                </tr>
                <tr *ngIf="(mOrderDetail?.order_status!='cancel' && mOrderDetail?.order_status!='cancelled' && mOrderDetail?.order_status!='Cancel' && mOrderDetail?.order_status!='Cancelled'); else cancel">
                    <td style="font-size: 12px;" *ngIf="mOrderDetail?.cod==false">Amount Paid ₹{{mOrderDetail?.order_amount}}</td>
                    <td style="font-size: 12px;" *ngIf="mOrderDetail?.cod==true">Amount To Be Paid ₹{{mOrderDetail?.order_amount}}</td>
                </tr>
                <ng-template #cancel>
                    <tr>
                        <td style="font-size: 12px;" *ngIf="mOrderDetail?.cod==true">ORDER CANCELLED</td>
                        <td style="font-size: 12px;" *ngIf="mOrderDetail?.cod==false">Amount Paid ₹{{mOrderDetail?.order_amount}}</td>
                    </tr>
                </ng-template>
            </table>
        </td>
    </tr>
    <tr>
        <td>
            <hr style="border: 1px solid #ccc;margin: 0;">
        </td>
    </tr>
    <tr>
        <td style="font-size: 12px;padding: 15px;" *ngIf="(mOrderDetail?.order_status=='cancel' || mOrderDetail?.order_status=='cancelled' || mOrderDetail?.order_status=='Cancel' || mOrderDetail?.order_status=='Cancelled'); else noCancel">Order Cancelled</td>
        <ng-template #noCancel>
            <td style="font-size: 12px;padding: 15px;" *ngIf="(mOrderDetail?.order_status=='deliver' || mOrderDetail?.order_status=='delivered' || mOrderDetail?.order_status=='Deliver' || mOrderDetail?.order_status=='Delivered'); else noDeliver">Package Delivered On {{showDate(mOrderDetail?.delivery_date)}}</td>

            <ng-template #noDeliver>
                <td style="font-size: 12px;padding: 15px;">Package will be Delivered by {{showDate(mOrderDetail?.delivery_date)}}</td>
            </ng-template>
        </ng-template>
    </tr>
    <tr>
        <td style="padding: 15px;">
            <table style="width: 100%;">
                <tr *ngFor="let product of mOrderDetail?.product_detail">
                    <td>
                        <table style="width: 100%;">
                            <tr>
                                <td style="width: 70px;padding-right: 10px;">
                                    <img style="max-width: 100%;"
                                        [src]="product?.imageList && product?.imageList.length > 0 && product?.imageList[0]?.path ? product.imageList[0].path : 'assets/images/default-product.png'"
                                        alt="image" />
                                </td>
                                <td>
                                    <table style="width: 100%;">
                                        <tr>
                                            <td style="font-size: 14px;">{{product?.name}}</td>
                                        </tr>
                                        <tr>
                                            <td style="font-size: 14px;">Qty: {{product?.product_qty}}</td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </table>
                    </td>
                    <td style="font-size: 14px;text-align: right;">
                        ₹{{product?.product_qty * product?.your_price}}
                    </td>
                </tr>
            </table>
        </td>
    </tr>
    <tr>
        <td>
            <hr style="border: 1px solid #ccc;margin: 0;">
        </td>
    </tr>
    <tr>
        <td style="padding: 15px;">
            <table style="width: 100%;">
                <tr>
                    <td style="font-size: 15px;" colspan="2">Payment Details</td>
                </tr>
                <tr>
                    <td style="padding-top:10px;font-size: 12px;width: 50%;">
                        Subtotal (Inclusive Tax)
                    </td>
                    <td style="padding-top:10px;font-size: 12px;width: 50%;text-align: right;">
                        ₹{{subTotalInclusiveTax}}
                    </td>
                </tr>
                <tr>
                    <td style="padding-top:10px;font-size: 12px;width: 50%;">
                        Discount
                    </td>
                    <td style="padding-top:10px;font-size: 12px;width: 50%;text-align: right;">
                        ₹{{mOrderDetail?.total_discount_amount}}
                    </td>
                </tr>
                <tr>
                    <td style="padding-top:10px;font-size: 12px;width: 50%;">
                        Shipping Charges
                    </td>
                    <td style="padding-top:10px;font-size: 12px;width: 50%;text-align: right;">
                        ₹{{mOrderDetail?.shipping_charge}}
                    </td>
                </tr>
                <tr>
                    <td style="padding-top:10px;font-size: 15px;width: 50%;font-weight: bold;">
                        Total:
                    </td>
                    <td style="padding-top:10px;font-size: 15px;width: 50%;text-align: right;font-weight: bold;">
                        ₹{{totalAmount}}
                    </td>
                </tr>
            </table>
        </td>
    </tr>
</table>